import 'jquery';
Bootstrap = window.Bootstrap = require('bootstrap');

window.autosize = require('autosize');
window.Sortable = require('sortablejs');

let version = '4.4.4';

/*

 jquery-easing.js
 global.js
 velocity.min.js
 chart.js
 wow.js
 scrolling-nav.js
 waves.js

 preloading.js
 card-reveal.js
 character-counter.js
 toasts.js
 smooth-scroll.js
 dropdown.js
 rotating-cards.js
 buttons.js
 hammer.js
 jquery.hammer.js
 sidenav.js
 collapsible.js
 jquery.easypiechart.js
 panel-popuot.js
 forms.js
 picker.js
 picker-date.js
 picker-time.js
 lightbox.js
 jquery.jsticky.js
 scrollbar.js
 animations.js
 chips.js
 autocomplete.js
 enhanced-modals.js

 */
// require('../../vendor/MDB Pro ' + version +'/js/mdb');

require('../../vendor/MDB Pro ' + version +'/js/modules (optional)/enhanced-modals')

require('../../vendor/MDB Pro ' + version +'/js/modules (optional)/jquery.easing');
require('../../vendor/MDB Pro ' + version +'/js/modules (optional)/velocity.min');
require('../../vendor/MDB Pro ' + version +'/js/modules (optional)/jquery.easypiechart');
require('../../vendor/MDB Pro ' + version +'/js/modules (optional)/chart');

/**
 * forms-free.js
 * @WARNING $hiddenDiv not found is found at
 * $hiddenDiv = $('<div class="hiddendiv common"></div>');
 *
 * should be let $hiddenDiv??
 *
 * define it first e.g $hiddenDiv
 */
require('../../vendor/MDB Pro ' + version +'/js/modules (optional)/forms-free');
require('../../vendor/MDB Pro ' + version +'/js/modules (optional)/material-select');

//
// let mdbModulesDir ='../../vendor/MDB Pro ' + version +'/js/modules (optional)/';
//
const toastr = window.toastr = require('../components/toastr');
//

Waves = window.Waves = require('../../vendor/MDB Pro ' + version +'/js/modules (optional)/waves');

window.WOW = require('wowjs');

// require('../../vendor/MDB Pro ' + version +'/js/modules (optional)/buttons');
require('../components/modified/est-mdb_buttons');
require('../../vendor/MDB Pro ' + version +'/js/modules (optional)/sidenav');
require('../../vendor/MDB Pro ' + version +'/js/modules (optional)/collapsible');
require('../../vendor/MDB Pro ' + version +'/js/modules (optional)/hammer');
require('../../vendor/MDB Pro ' + version +'/js/modules (optional)/jquery.hammer');
/********************************************/
/**
 * picker-date.js
 * WARNING  a fix has been applied to picker-date.js where the module failed to import
 * replace all in module setup
 * LIKE BELOW!!!
 (function (factory) {

	module.exports = factory( require('./picker.js'), require('jquery') )

}(function (Picker, $) {
 */
require('../../vendor/MDB Pro ' + version +'/js/modules (optional)/picker');
require('../../vendor/MDB Pro ' + version +'/js/modules (optional)/picker-date');
require('../../vendor/MDB Pro ' + version +'/js/modules (optional)/picker-time');

/********************************************/

require('../../vendor/MDB Pro ' + version +'/js/modules (optional)/dropdown');
// require('../../vendor/MDB Pro ' + version +'/js/modules (optional)/animations'); //removed from 4.3.3
// require('../../vendor/MDB Pro ' + version +'/js/modules (optional)/autocomplete');
require('../../vendor/MDB Pro ' + version +'/js/modules (optional)/smooth-scroll');
require('../../vendor/MDB Pro ' + version +'/js/modules (optional)/scrollbar');
require('../../vendor/MDB Pro ' + version +'/js/modules (optional)/scrolling-navbar');
require('../../vendor/MDB Pro ' + version +'/js/modules (optional)/jquery.sticky');

$(function () {
    /**
     * waves.js
     * WARNING  a fix has been applied to picker-date where the module failed to import
     * I was able to get around this by refactoring the Waves factory to simply attach the factory's result to the
     * window.window.Waves = factory.call(window);
     */
    /*
    (function (window, factory) {
        'use strict';
        window.Waves = factory.call(window);
    */

    /**
     * waves.js
     * Below is no longer necessary to comment out in waves.js
     */

	// Waves.attach('.btn:not(.btn-flat), .btn-floating', ['waves-light']);
	// Waves.attach('.basket-btn', ['waves-effect']);
	// Waves.attach('.view .mask', ['waves-light']);
	// Waves.attach('.waves-light', ['waves-light']);
	// Waves.attach('.waves-effect', ['waves-effect']);
	// Waves.attach('.navbar-nav a:not(.navbar-brand), .nav-icons li a, .navbar form, .nav-tabs .nav-item', ['waves-light']);
	// Waves.attach('.pager li a', ['waves-light']);
	// Waves.attach('.pagination .page-item .page-link', ['waves-effect']);
    // window.Waves.attach('.btn', ['waves-effect']);
	// window.Waves.init();
	//
	// console.log('Waves',Waves);

	$('[data-toggle="popover"]').popover();
	var materialSelect = $('.mdb-select').material_select();
	// console.log('materialSelect',materialSelect);
});





// WEBPACK FOOTER //
// ./resources/assets/js/config/materialDesign.js